export default __webpack_public_path__ + "static/media/linkedIn.3a2357df.png";